export default {
  LOADING: "loading",
  PLAYING: "playing",
  PAUSED: "paused",
  COMPLETED: "completed",
  ERROR: "error",
};
